import io from 'socket.io-client';
import config from '../../config';
import { SOCKET_URL } from '../utils/Const';
class SocketService {
    constructor() {
        this.socket = null;
        this.reconnectInterval = null;
        this.connected = false;
        this.reconnected = false; 
        this.pushNotificationsRef = null;
        this.notificationCenterRef = null;
    }

    setPushNotificationsRef(ref) {
        this.pushNotificationsRef = ref;
    }
    
    setNotificationCenterRef(ref) {
        this.notificationCenterRef = ref;
    }

    async connect () {
        if (!this.socket) {

            if (this.reconnectInterval) {
                clearInterval(this.reconnectInterval);
                this.reconnectInterval = null;
            }

            this.socket = await io(SOCKET_URL, {
                reconnection: false 
            });

            await this.listenConnection();

            await this.connectionError();
        }
        return this.socket;
    }

    listenConnection () {
        this.socket.on('connect', () => {
            if(this.reconnected){
                const currentUser = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
                const { U_FMB_Sucursal, Sucursal, USERID, USER_CODE, ReferredUser } = currentUser;

                if(currentUser && currentUser.USERID){
                    const data = {
                        pkSucursal: U_FMB_Sucursal,
                        sucursal: Sucursal,
                        userID: USERID,
                        userCode: USER_CODE,
                        ReferredUser,
                    };

                    this.emit('login', (data));
                }

                this.reconnected = false; 
            }
            this.connected = true; 
            this.listenNotification();
            this.setupReconnectHandler();
        });
    }

    listenNotification () {
        this.socket.on('notification', (data) => {
            if (this.pushNotificationsRef && this.pushNotificationsRef.current) {
                this.pushNotificationsRef.current.addNotification(data);
            }
            if (this.notificationCenterRef) {
                this.notificationCenterRef.getNotifications();
            }
        });
    }

    connectionError () {
        this.socket.on('connect_error', (error) => {
            this.socket = null;
            this.connected = false; 
            this.scheduleReconnect();
        });
    }

    setupReconnectHandler () {
        this.socket.on('disconnect', () => {
            this.connected = false; 
            this.socket = null;
            this.scheduleReconnect();
        });
    }

    // Funcion para tratar de reconectarse cada 5 mins
    scheduleReconnect () {
        this.reconnected = true; 
        this.reconnectInterval = setInterval(() => {            
            this.connect();
        }, 5 * 60 * 1000); 
    }

    on(event, callback) {
        if (this.socket) {
            this.socket.on(event, callback);
        }
    }

    emit(event, data) {
        if (this.socket) {
            this.socket.emit(event, data);
        }
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }

        if (this.reconnectInterval) {
            clearInterval(this.reconnectInterval);
            this.reconnectInterval = null;
        }
    }
}

const socketService = new SocketService();
export default socketService;